'use client';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export interface HelpSectionProps {
  id: string;
  title: string;
  description: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  expanded: boolean;
  onChange: (id: string) => void;
}

export function HelpSection({
  id,
  title,
  description,
  icon,
  children,
  expanded,
  onChange,
}: HelpSectionProps) {
  return (
    <Accordion
      expanded={expanded}
      onChange={() => onChange(id)}
      id={id}
      sx={{
        '&:before': { display: 'none' },
        '&.Mui-expanded': { margin: 0 },
        border: 1,
        borderColor: 'divider',
        borderRadius: '8px !important',
        mb: 2,
        overflow: 'hidden',
      }}
      elevation={0}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${id}-content`}
        id={`${id}-header`}
        sx={{
          '&.Mui-expanded': { minHeight: 56 },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          {icon}
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0 }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
}
